<template>
    <div class="modal">
        <div class="modal-background" @click="hide()"></div>
        <div class="modal-card">
            <slot name="header" />
            <slot name="content" />
            <slot name="footer" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'modal',
    props: {
        onClose: {
            type: Function
        }
    },
    data() {
        return {};
    },
    methods: {
        hide() {
            this.onClose();
        }
    }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/modals/modal.vue